import { Avatar, Stack, CircularProgress } from '@mui/material'
import { G_Filled_Color, B_Filled_Color, R_Filled_Color, W_Filled_Color, Y_Filled_Color } from '@edge/spark/ui-assets'

const imgDict: Record<string, JSX.Element> = {
    G: <img src={G_Filled_Color} key="G" alt="Green Icon" />,
    Y: <img src={Y_Filled_Color} key="Y" alt="Yellow Icon" />,
    R: <img src={R_Filled_Color} key="R" alt="Red Icon" />,
    B: <img src={B_Filled_Color} key="B" alt="Blue Icon" />,
    W: <img src={W_Filled_Color} key="W" alt="White Icon" />,
}

const LoadingLightStartIcon = () => {
    return <CircularProgress size={24} />
}

const UnknownLightStartIcon = ({ color }: { color: string }) => {
    return <Avatar sx={{ height: 24, width: 24, fontWeight: 400, fontSize: '1rem' }}>{color}</Avatar>
}

export const LightStartIcons = ({ colors, loading }: { colors?: string[]; loading?: boolean }) => {
    if (loading) {
        return <LoadingLightStartIcon />
    }

    if (!colors?.length) {
        return <UnknownLightStartIcon color="?" />
    }

    return (
        <Stack direction="row" gap={0.5}>
            {colors.map((color) => imgDict[color] || <UnknownLightStartIcon key="unknown" color={color} />)}
        </Stack>
    )
}
